import { render, staticRenderFns } from "./OwnerSidebar.vue?vue&type=template&id=3b151690&scoped=true&"
import script from "./OwnerSidebar.vue?vue&type=script&lang=js&"
export * from "./OwnerSidebar.vue?vue&type=script&lang=js&"
import style0 from "./OwnerSidebar.vue?vue&type=style&index=0&id=3b151690&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b151690",
  null
  
)

export default component.exports